import { render, staticRenderFns } from "./newHome.vue?vue&type=template&id=a291d86c&scoped=true"
import script from "./newHome.vue?vue&type=script&lang=js"
export * from "./newHome.vue?vue&type=script&lang=js"
import style0 from "@/styles/pc.css?vue&type=style&index=0&id=a291d86c&prod&scoped=true&lang=css&external"
import style1 from "./newHome.vue?vue&type=style&index=1&id=a291d86c&prod&lang=scss"
import style2 from "./newHome.vue?vue&type=style&index=2&id=a291d86c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a291d86c",
  null
  
)

export default component.exports